import {inject, Injectable} from '@angular/core';
import {LocalStorageKeys} from '../models/server/Constants';
import {ParamMap, Params} from "@angular/router";
import {firstValueFrom, Subscription} from "rxjs";
import {LocalStoreService} from "./local-store.service";

export enum RecentActivityKind {
  Label,
  Table,
  Console
}

export interface RecentActivity {
  label: string;
  kind: RecentActivityKind,
  url: string;
  params: Params;
}

// keep a stack of the recent activity
@Injectable({
  providedIn: 'root'
})
export class RecentActivityService {

  // injected services
  private localStore = inject(LocalStoreService);

  stackSize = 7;  // why not

  private recentActivity: Array<RecentActivity>;
  private qpm: Subscription;

  constructor() {
    this.clear();
    this.load();
  }

  public clear() {
    this.recentActivity = new Array<RecentActivity>();
  }

  public list(): Array<RecentActivity> {
    return this.recentActivity;
  }

  public add(recentAct: RecentActivity): void {

    // remove dupes
    while (true) {
      let i = this.recentActivity.findIndex((v, index) => v.label === recentAct.label && v.kind === recentAct.kind);
      if (i >= 0) {
        this.recentActivity.splice(i, 1);
      } else {
        break;
      }
    }

    this.recentActivity.unshift(recentAct);

    if (this.recentActivity.length > this.stackSize) {
      this.recentActivity.length = this.stackSize;
    }
    this.localStore.setItem(LocalStorageKeys.LastPage, recentAct.url);
    this.save();
  }

  private async load(): Promise<void> {
    const j = await this.localStore.getDBItem(LocalStorageKeys.RecentActivity);
    if (j) {
      Object.assign(this.recentActivity, j);
    }
  }

  private async save(): Promise<void> {
    await this.localStore.setDBItem(LocalStorageKeys.RecentActivity, this.recentActivity);
  }

}

